import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    backLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Back button to the list of projects */
            backLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MoveToCopyTo.backLabel?c=2hodk36htwsl", defaultMessage: "Go back" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
